import { useState } from 'react';
import { cn } from '@/lib/utils';
import { scrollToId } from '@/lib/utils';
import { Button } from '@/components/ui/Button';

const NAV_LINKS = [
  { label: 'How It Works', id: 'how-it-works' },
  { label: 'See Demo', id: 'decay-demo' },
  { label: 'Shoppers', id: 'shoppers' },
  { label: 'Merchants', id: 'merchants' },
  { label: 'FAQ', id: 'faq' },
];

export function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 border-b border-gray-200 bg-white/90 backdrop-blur-md">
      <div className="container mx-auto flex h-16 items-center justify-between px-6">
        <a href="#" className="text-xl font-extrabold tracking-tight text-gray-900">
          Run<span className="text-brand-500">2</span>Sale
        </a>

        {/* Desktop links */}
        <ul className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((link) => (
            <li key={link.id}>
              <button
                onClick={() => scrollToId(link.id)}
                className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900"
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <Button size="sm" onClick={() => scrollToId('waitlist')}>
            Join Waitlist
          </Button>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden"
          aria-label="Menu"
          onClick={() => setOpen(!open)}
        >
          <svg width={24} height={24} fill="none" stroke="currentColor" strokeWidth={2}>
            {open ? (
              <path d="M6 6l12 12M6 18L18 6" />
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={cn(
          'overflow-hidden border-t border-gray-100 transition-all duration-200 md:hidden',
          open ? 'max-h-80' : 'max-h-0 border-t-0',
        )}
      >
        <div className="container mx-auto flex flex-col gap-2 px-6 py-4">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => { scrollToId(link.id); setOpen(false); }}
              className="rounded-lg px-3 py-2 text-left text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
            >
              {link.label}
            </button>
          ))}
          <Button size="sm" className="mt-2" onClick={() => { scrollToId('waitlist'); setOpen(false); }}>
            Join Waitlist
          </Button>
        </div>
      </div>
    </nav>
  );
}
